import achievements from "./achievements";
import aiContent from "./ai-content";
import apps from "./apps";
import articles from "./articles";
import attributes from "./attributes";
import audienceSegments from "./audience-segments";
import auth from "./auth";
import beacons from "./beacons";
import buildings from "./buildings";
import collections from "./collections";
import contacts from './contacts';
import conversations from './conversations';
import documents from "./documents";
import elements from "./elements";
import eventSeries from "./event-series";
import eventTypes from "./event-types";
import events from "./events";
import exhibitTypes from "./exhibit-types";
import exhibits from "./exhibits";
import facilities from "./facilities";
import facilityTypes from "./facility-types";
import factTemplates from "./fact-templates";
import feedback from './feedback';
import files from "./files";
import floors from "./floors";
import frames from "./frames";
import greetings from "./greetings";
import imports from "./imports";
import insights from "./insights";
import interactionAreas from "./interaction-areas";
import lessonPlans from "./lesson-plans";
import levels from "./levels";
import links from "./links";
import maps from "./maps";
import membershipPlans from "./membership-plans";
import memberships from "./memberships";
import messages from "./messages";
import notes from "./notes";
import offers from "./offers";
import operators from "./operators";
import organisations from "./organisations";
import physicalObjects from "./physical-objects";
import places from "./places";
import qrCodes from "./qr-codes";
import quizTypes from "./quiz-types";
import quizzes from "./quizzes";
import redemptions from "./redemptions";
import roles from "./roles";
import settings from "./settings";
import sites from "./sites";
import sponsorshipTiers from "./sponsorship-tiers";
import sponsorships from "./sponsorships";
import spotlights from "./spotlights";
import tags from "./tags";
import ticketTypes from "./ticket-types";
import tickets from "./tickets";
import trailRatings from './trail-rating';
import trailWaypoints from './trail-waypoint';
import trails from './trail';
import triggers from "./triggers";
import users from "./users";
import visits from './visits';
import vouchers from "./vouchers";
import zones from "./zones";

const ngage = {
    achievements,
    aiContent,
    apps,
    articles,
    attributes,
    audienceSegments,
    auth,
    beacons,
    buildings,
    collections,
    contacts,
    conversations,
    documents,
    elements,
    eventSeries,
    eventTypes,
    events,
    exhibitTypes,
    exhibits,
    facilities,
    facilityTypes,
    factTemplates,
    feedback,
    files,
    floors,
    frames,
    greetings,
    imports,
    insights,
    interactionAreas,
    lessonPlans,
    levels,
    links,
    maps,
    membershipPlans,
    memberships,
    messages,
    notes,
    offers,
    operators,
    organisations,
    physicalObjects,
    places,
    qrCodes,
    quizTypes,
    quizzes,
    redemptions,
    roles,
    settings,
    sites,
    sponsorshipTiers,
    sponsorships,
    spotlights,
    tags,
    ticketTypes,
    tickets,
    trailRatings,
    trailWaypoints,
    trails,
    triggers,
    users,
    visits,
    vouchers,
    zones,
}

export default ngage